import { Component, Fragment, Prop, Watch, h } from '@stencil/core';

import { onAcceptOffer } from '../../../../actions/actions.counteroffer';
import track from '../../../../tracking/tracking.counteroffer';
import { isClosedByUser, scheduleAutoClosing } from '../../../../utils/utils.counteroffer';
import { BulletList, Footer, ModalHeader } from '../Shared';

@Component({
  tag: 'accept-offer-dialog',
  styleUrl: 'accept-offer-dialog.css',
})
export class CertificateAcceptOffer {
  @Prop() offerAmount: string = '';
  @Prop() accepted: boolean = false;
  @Prop() isSubmitting: boolean = false;
  @Prop({ mutable: true }) modal: HTMLIcoModalElement;

  handleClickAccept = () => {
    onAcceptOffer();
  };

  @Watch('accepted')
  onAccepted() {
    scheduleAutoClosing(this.modal);
  }

  onClosing = () => {
    if (isClosedByUser(this.modal)) {
      track.acceptOffer.close(this.accepted);
    }
  };

  render() {
    return (
      <ico-counteroffer-modal displayX class="font-open-sans" dataTestId="accept-offer" shouldCloseOnBackdrop={false} ref={(el) => (this.modal = el)} callback={this.onClosing}>
        <ModalHeader>
          {this.accepted ? <span>Congratulations! Your acceptance has been successfully submitted.</span> : <span>Ready to move forward and accept your Offer?</span>}
        </ModalHeader>
        {this.accepted ? (
          <BulletList>
            What happens next:
            <li>
              A participating dealer will reach out to you about your Offer and <span class="inline-block">set up an appointment.</span>
            </li>
          </BulletList>
        ) : (
          <>
            <div class="text-sm font-bold">
              Your Kelley Blue Book® <span class="whitespace-nowrap">Instant Cash Offer</span>
            </div>

            <div class="flex max-sm:flex-col sm:flex-row justify-between max-sm:items-start sm:items-center mt-2 max-sm:gap-4">
              <div class="text-5xl font-bold text-clrs-green" data-testid="accept-offer-price">
                {this.offerAmount}
              </div>
              <ico-button
                label={this.isSubmitting ? '...' : 'Yes!'}
                buttonSize="large"
                class="max-sm:w-full sm:w-auto h-full"
                onClick={this.handleClickAccept}
                disabled={this.isSubmitting}
                data-testid="confirm-accept-offer-btn"
              />
            </div>
          </>
        )}

        <div class="text-label mt-8 sm:mt-4">
          <Footer />
        </div>
      </ico-counteroffer-modal>
    );
  }
}
